import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ChurnDistributionDto } from '../../../models/churn-prediction/dto/churn-prediction.dto';

export const GET_CHURN_DISTRIBUTION_QUERY_KEY = (organizationId: string) => [
  'churn-distribution',
  organizationId,
];

export function useGetChurnDistribution(organizationId?: string) {
  const apiClient = useApiClient();

  return useQuery<ChurnDistributionDto>({
    enabled: Boolean(organizationId),
    queryKey: GET_CHURN_DISTRIBUTION_QUERY_KEY(organizationId!),
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<ChurnDistributionDto> => {
      const response = await apiClient.fetchApi<ChurnDistributionDto, {}>({
        method: 'GET',
        endpoint: `churn-prediction/admin/${organizationId}/distribution`,
      });
      return response;
    },
  });
}
